module.exports = __webpack_public_path__ + "static/media/BR.7ab560bb.png";